export const PROJECT_INIT_PLATFORM = Object.freeze({
  JUNCTION: 'Junction',
  DIGITAL_START: 'Digital Start',
  DTP: 'DTP',
  CONCOURSE: 'Concourse',
});
